import { useOutletContext } from 'react-router-dom'

import { TrainingSessionsByEmployeeDataTableQuery } from 'generated/resources/datatable.graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { UploadCertificate } from 'modules/trainings/components/MyTrainings/UploadCertificate'

type TrainingsSessionAccessMembership = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<TrainingSessionsByEmployeeDataTableQuery['trainings']>['sessionsConnection']
    >['edges'][0]
  >['node']
>

const EmployeeSessionModalUploadCertificateModal = () => {
  const { navigation } = useNavigation()
  const { employeeId, employeeAccessId, trainingId, session } = useOutletContext<{
    employeeId: number
    employeeAccessId: number
    trainingId: number
    session: TrainingsSessionAccessMembership
  }>()
  return (
    <UploadCertificate
      accessId={employeeAccessId}
      navigateBackTo={navigation.employees.id.training.detail.view.sessionDetail.fullPath({
        id: employeeId,
        trainingId,
        sessionId: session.id,
      })}
    />
  )
}

export default EmployeeSessionModalUploadCertificateModal
